<template>
  <div v-if="training._id">
    <div class="page-title"> 훈련 개요 </div>
    <label-text label="개설과정명" :width="labelWidth">
      <span class="bolder title">{{training.name}}</span>
    </label-text>
    <label-text label="기관" :width="labelWidth">{{training.org.name}}</label-text>
    <label-text label="훈련대상" :width="labelWidth">{{training.target}}</label-text>
    <label-text label="수준"  :width="labelWidth">{{training.level}}</label-text>
    <label-text label="강사"  :width="labelWidth">{{training.teacher.name}}</label-text>
    <label-text label="평가 과락 기준"  :width="labelWidth">{{training.failScore}}점</label-text>
    <label-text label="학습기간"  :width="labelWidth">
      {{$strDate(training.startDate)}} ~ {{$strDate(training.endDate)}} /
      {{training.months}} 개월 /
      {{training.hours}} 시간
    </label-text>
    <label-text label="훈련 목표" :width="labelWidth">
      <div v-html="training.objective"/>
    </label-text>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import LabelText from '../../../components/common/LabelText.vue';
export default {
  name: 'TraingOverviewEdit',
  components: { LabelText },
  data: () => ({
    labelWidth: '120px'
  }),
  computed: mapState('training', ['training'])
}
</script>
